module.exports = __webpack_public_path__ + "img/fwg_tranparent.218a10b8.png";